import React from "react";
import { useIntl } from "react-intl";
import { ParagraphOutputRaw } from "@/model/paragraph";
import { CodeEditor } from "@/component/input";

import { ParagraphInputsProps } from "../model";


const ParagraphOutputRawCardInputs: React.FC<ParagraphInputsProps<ParagraphOutputRaw>> = (props) => {
    const { paragraph, onChange } = props;

    const intl = useIntl();

    return (
        <div className="col-span-2 flex flex-col gap-1.5">
            <div className="h-6 flex items-center field-label">
                {intl.formatMessage({ id: "i04032" })}
            </div>
            <CodeEditor mode="json"
                        height="250px"
                        value={paragraph.data ?? ""}
                        onChange={value => onChange({
                            ...paragraph,
                            data: value
                        })}
            />
        </div>
    );
};

export default ParagraphOutputRawCardInputs;
